module.exports = __webpack_public_path__ + "img/sand_warrior.8d74d004.jpg";